import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	text: {}
})

export default useStyles
